<template>
  <div :class="$style.box">
    <img :class="$style['head-image']" :src="headImage" alt="头像" />
    <div
      :class="$style['head-circle-image']"
      :style="{ backgroundImage: `url(${headCircleImage})` }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    // 用户头像
    headImage: {
      type: String,
      default: ''
    },
    // 用户身份信息标识图片（头像外层圆环图片）
    headCircleImage: {
      type: String,
      default: ''
    },
  },
};
</script>

<style lang="scss" module>
.box {
  position: relative;
  left: -9px;
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  font-size: 16px;
  .head-image {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0px);
    width: 38px;
    height: 38px;
    border-radius: 50%;
  }
  .head-circle-image {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    background-position: -4px -4px;
    background-size: 61px 61px;
    background-repeat: no-repeat;
  }
}
</style>
